export default __webpack_public_path__ + "static/assets/cf41094d71c8ed9d83023313a48168b9.png";